module.exports = __webpack_public_path__ + "static/media/2.72b9f7ad.jpg";